/* home-hyper.js — positions + hydrates the SSR homepage (.cc-home) and the site-wide glass chrome
   (.cc-chrome-top / .cc-chrome-foot), hides the old header/footer/home body with zero flash, and wires
   every nav link / CTA / footer link / icon to its real page. Ported from localhost:5700 popup-research/home.js.
   Loaded site-wide (deferred) from layout/theme.liquid. Coexists with cro.js (whose Module 7 popup is retired). */
(function () {
  'use strict';
  if (window.__ccHome) return; window.__ccHome = true;
  var d = document, root = d.documentElement;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var txt = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };

  /* ---- navigation targets (matched by exact trimmed link text) ---- */
  var NAV = {
    'SteadyRide System': '/products/steady-ride-system',
    'Full Seat Cover': '/products/full-seat-cover',
    'Single Seat Cover': '/products/single-seat-cover',
    'Travel Bed': '/products/travel-bed',
    'Shop': '/pages/shop',
    'Shop the SteadyRide System': '/products/steady-ride-system',
    'Shop all products': '/pages/shop',
    'Shop the bundle': '/products/steady-ride-system',
    'Keep them safe': '/products/steady-ride-system'
  };
  /* product-card / sticky "Add to cart" -> product handle for quick-add (variant fetched live, no hardcoded ids) */
  var CARD_HANDLE = {
    'Full Seat Cover': 'full-seat-cover',
    'Custom-Fit Travel Bed': 'travel-bed',
    'SteadyRide System': 'steady-ride-system',
    'Pet Water Fountain': 'pet-water-fountain'
  };
  var SEARCH = [
    { name: 'SteadyRide System', price: '319.90', was: '', url: '/products/steady-ride-system', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/swap-petride-steady-ride-system-2-v2.webp?v=1784204146', kw: 'steadyride steady ride system bundle cover bed combo kit' },
    { name: 'Full Seat Cover', price: '239.90', was: '', url: '/products/full-seat-cover', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-full-seat-cover.webp?v=1793250490', kw: 'full seat cover hard base back seat hammock large protector' },
    { name: 'Single Seat Cover', price: '219.90', was: '', url: '/products/single-seat-cover', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-single-seat-cover.webp?v=1793250493', kw: 'single seat cover front bucket one seat protector' },
    { name: 'Travel Bed', price: '199.90', was: '', url: '/products/travel-bed', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-travel-bed.webp?v=1793250496', kw: 'travel bed mattress custom fit portable' },
    { name: 'Pet Water Fountain', price: '259.90', was: '', url: '/products/pet-water-fountain', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-tile-pet-water-fountain.webp?v=1793250499', kw: 'pet water fountain drink hydration filtered bowl' },
    { name: 'Replacement Filters', price: '49.90', was: '', url: '/products/replacement-filters', img: 'https://cdn.shopify.com/s/files/1/0957/0847/9772/files/petride-replacement-filters-1-v3.png?v=1782969811', kw: 'replacement filters water fountain refill charcoal' }
  ];

  /* ---------- 1. POSITION the SSR blocks + hide the old chrome/home body ---------- */
  function position() {
    var body = d.body;
    var ccHome = $('.cc-home[data-cc-home]');           // homepage: full block (chrome+body+footer)
    var ccTop = $('.cc-chrome-top[data-cc-chrome-top]'); // inner pages: announce+header
    var ccFoot = $('.cc-chrome-foot[data-cc-chrome-foot]');
    if (ccHome) {
      body.insertBefore(ccHome, body.firstChild);
      var main = $('#MainContent');
      if (main) main.classList.add('cc-oldhome-hidden');   // hide old homepage body
    }
    if (ccTop) body.insertBefore(ccTop, body.firstChild);
    if (ccFoot) body.appendChild(ccFoot);
    // belt-and-braces: hide old chrome groups directly (CSS also does this on cc-home-on)
    $$('.shopify-section-group-header-group, .shopify-section-group-footer-group').forEach(function (el) {
      if (!el.closest('.cc-home') && !el.closest('.cc-chrome-top') && !el.closest('.cc-chrome-foot')) el.style.display = 'none';
    });
  }

  /* ---------- 2. WIRE navigation (set real hrefs on inert links / CTAs) ---------- */
  function wireNav() {
    $$('.cc-home a, .cc-chrome-top a, .cc-chrome-foot a').forEach(function (a) {
      if (a.getAttribute('href')) return;                 // already linked (Resources menu, footer, search)
      var t = txt(a);
      if (NAV[t]) a.setAttribute('href', NAV[t]);
    });
    // CTA <button>s that map to a page ("Shop the SteadyRide System", "Shop all products", "Shop the bundle", "Keep them safe") — navigate on click. Add-to-cart + icon/menu buttons are excluded (they have no matching NAV text).
    $$('.cc-home button, .cc-chrome-top button, .cc-chrome-foot button').forEach(function (b) {
      if (b.hasAttribute('data-add') || b.getAttribute('data-cc-nav')) return;
      var t = txt(b);
      var key = NAV[t] ? t : Object.keys(NAV).filter(function (k) { return t.indexOf(k) === 0; }).sort(function (x, y) { return y.length - x.length; })[0];
      if (!key) return;
      var href = NAV[key];
      b.setAttribute('data-cc-nav', href); b.style.cursor = 'pointer';
      b.addEventListener('click', function () { location.href = href; });
    });
    // mark the CURRENT page's header nav link as active (orange pill / white text, like the Shop CTA)
    var pn = location.pathname.replace(/\/+$/, '');
    $$('.hm-nav > a').forEach(function (a) {
      var h = (a.getAttribute('href') || '').replace(/^https?:\/\/[^/]+/, '').replace(/\/+$/, '');
      if (h && h === pn) a.classList.add('is-active'); else if (a.classList.contains('is-active') && !a.classList.contains('hm-nav-shop')) a.classList.remove('is-active');
    });
    // logo -> home
    $$('.hm-logo').forEach(function (l) { l.style.cursor = 'pointer'; l.setAttribute('role', 'link'); l.setAttribute('aria-label', 'PetRide home'); l.addEventListener('click', function () { location.href = '/'; }); });
    // account + cart icons (buttons)
    $$('.hm-headacts button[title="Account"]').forEach(function (b) { b.addEventListener('click', function () { location.href = '/account'; }); });
    $$('.hm-headacts button[title="Cart"]').forEach(function (b) { b.addEventListener('click', openCart); });
    // "Add to cart" buttons (product cards + sticky)
    $$('.cc-home [data-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var card = b.closest('.hm-card') || b.closest('.hm-sticky');
        var name = card ? txt(card.querySelector('.hm-card-t, .hm-sticky-t b, b')) : '';
        var handle = CARD_HANDLE[name] || 'steady-ride-system';
        quickAdd(handle, b);
      });
    });
  }

  function quickAdd(handle, btn) {
    return; /* 29 Oct 2026: whole store sold out, quick add switched off */
    if (btn) {
      if (btn.getAttribute('data-cc-busy')) return;            // guard against double-clicks
      btn.setAttribute('data-cc-busy', '1');
      btn.setAttribute('data-cc-old', btn.innerHTML);
      btn.disabled = true;
      btn.innerHTML = 'Adding to cart <span class="cc-spin" aria-hidden="true"></span>';
    }
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) });
    }).then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      // open the SAME fold-in cart drawer with the added item — never redirect to /cart (that was the flash-to-old-cart bug)
      .then(function () { if (window.__croRefreshCart) return window.__croRefreshCart(true); openCart(); })
      // drawer is now open with the item -> flip to a green "Added ✓", then revert to the original label
      .then(function () { addedAddBtn(btn); })
      .catch(function () { restoreAddBtn(btn); });
  }
  function restoreAddBtn(btn) {
    if (!btn) return;
    if (btn._ccRevT) { clearTimeout(btn._ccRevT); btn._ccRevT = null; }
    btn.classList.remove('cc-atc-added');
    var old = btn.getAttribute('data-cc-old');
    if (old != null) btn.innerHTML = old;
    btn.disabled = false;
    btn.removeAttribute('data-cc-busy');
    btn.removeAttribute('data-cc-old');
  }
  function addedAddBtn(btn) {
    if (!btn) return;
    btn.disabled = false;
    btn.classList.add('cc-atc-added');
    btn.innerHTML = 'Added <span aria-hidden="true">✓</span>';
    if (btn._ccRevT) clearTimeout(btn._ccRevT);
    btn._ccRevT = setTimeout(function () { restoreAddBtn(btn); }, 2600);
  }

  function openCart() {
    // Open the drawer SYNCHRONOUSLY first so the button always responds instantly, even when the cart is
    // empty or the click lands mid-boot before cro finishes. cro then refreshes + re-opens with fresh contents.
    var drawer = $('cart-drawer');
    if (drawer) { drawer.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
    if (window.__croRefreshCart) { try { window.__croRefreshCart(true); return; } catch (e) {} }
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    var trig = $('#cart-icon-bubble');
    if (drawer && trig) { try { trig.click(); return; } catch (e) {} }
    location.href = '/cart';
  }

  /* ---------- 3. INTERACTIONS ---------- */
  function wireInteractions() {
    // FAQ: native <details.hm-faq-item>; sync .is-open for the +/- marker
    $$('.hm-faq-item').forEach(function (det) {
      det.addEventListener('toggle', function () { det.classList.toggle('is-open', det.open); });
    });
    // Resources dropdown
    d.addEventListener('click', function (e) {
      var res = e.target.closest('[data-res]');
      var wrap = $('.hm-nav-res');
      if (res && wrap) { e.preventDefault(); wrap.classList.toggle('is-open'); res.setAttribute('aria-expanded', wrap.classList.contains('is-open')); return; }
      if (wrap && wrap.classList.contains('is-open') && !e.target.closest('.hm-nav-res')) wrap.classList.remove('is-open');
      // Search: toggle
      var sb = e.target.closest('[data-search]');
      var panel = $('.hm-search');
      if (sb && panel) { e.preventDefault(); toggleSearch(); return; }
      if (panel && panel.classList.contains('is-open') && !e.target.closest('.hm-search') && !e.target.closest('[data-search]')) panel.classList.remove('is-open');
      if (e.target.closest('[data-search-clear]')) { var i = $('#hmSearchInput'); if (i) { i.value = ''; renderSearch(''); i.focus(); } }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var w = $('.hm-nav-res'); if (w) w.classList.remove('is-open'); var p = $('.hm-search'); if (p) p.classList.remove('is-open'); closeDrawer(); }
    });
    var si = $('#hmSearchInput');
    if (si) si.addEventListener('input', function () { renderSearch(si.value); });
  }
  function toggleSearch() {
    var panel = $('.hm-search'); if (!panel) return;
    var open = panel.classList.toggle('is-open');
    if (open) { renderSearch(''); var i = $('#hmSearchInput'); if (i) setTimeout(function () { i.focus(); }, 40); }
  }
  function hmEsc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hmSearchRow(p) {
    var was = p.was ? '<s>$' + p.was + '</s> ' : '';
    return '<a class="hm-sr" href="' + p.url + '">' +
      '<img src="' + p.img + '" alt="' + hmEsc(p.name) + '" loading="lazy">' +
      '<span class="hm-sr-t"><b>' + hmEsc(p.name) + '</b><span class="hm-sr-p">' + was + '<em>$' + p.price + '</em></span></span>' +
      '<span class="hm-sr-go" aria-hidden="true">→</span></a>';
  }
  function renderSearch(q) {
    var box = $('#hmSearchResults'); if (!box) return;
    q = (q || '').trim().toLowerCase();
    var clr = $('[data-search-clear]'); if (clr) { if (q) clr.removeAttribute('hidden'); else clr.setAttribute('hidden', ''); }
    var matches = [], rest = SEARCH.slice();
    if (q) {
      var toks = q.split(/\s+/);
      var scored = SEARCH.map(function (p) {
        var nm = p.name.toLowerCase(), hay = (p.name + ' ' + p.kw).toLowerCase(), s = 0;
        toks.forEach(function (t) { if (nm.indexOf(t) === 0) s += 4; else if (nm.indexOf(t) !== -1) s += 2; else if (hay.indexOf(t) !== -1) s += 1; });
        return { p: p, s: s };
      });
      matches = scored.filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.p; });
      rest = SEARCH.filter(function (p) { return matches.indexOf(p) === -1; });
    }
    var html = '';
    if (!q) { html = '<div class="hm-sr-head">Popular products</div>' + rest.map(hmSearchRow).join(''); }
    else if (matches.length) {
      html = '<div class="hm-sr-head">' + matches.length + ' result' + (matches.length > 1 ? 's' : '') + ' for “' + hmEsc(q) + '”</div>' + matches.map(hmSearchRow).join('');
      if (rest.length) html += '<div class="hm-sr-head hm-sr-rec">You might also like</div>' + rest.map(hmSearchRow).join('');
    } else {
      html = '<div class="hm-sr-empty">No matches for “' + hmEsc(q) + '”. Try “cover”, “bed” or “fountain”.</div><div class="hm-sr-head hm-sr-rec">Recommendations</div>' + rest.map(hmSearchRow).join('');
    }
    box.innerHTML = html;
  }

  /* ---------- 4. MOBILE NAV — open cro.js's existing "Full CRO stack" drawer (Module 9), already built
     into #menu-drawer at <body> level. Reuse cro's own open/close toggle (summary listener). ---------- */
  function wireDrawer() {
    $$('.hm-burger').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var summary = $('summary.header__icon--menu') || $('#Details-menu-drawer-container summary');
        if (summary) { summary.click(); return; }   // cro's capture-phase listener toggles the drawer
        root.classList.add('cce-nav-open');           // fallback: replicate cro's openNav()
        var dr = $('#menu-drawer'); if (dr) dr.style.setProperty('transform', 'translateX(0)', 'important');
      });
    });
  }

  /* ---------- 5. REVEAL (zero-flash: only after everything is positioned) ---------- */
  function reveal() {
    root.classList.add('cc-home-on');
    root.classList.remove('cc-home-boot');
    if (window.__ccHomeSafety) { clearTimeout(window.__ccHomeSafety); window.__ccHomeSafety = null; }
  }

  function init() {
    try {
      position();
      wireNav();
      wireInteractions();
      wireDrawer();
    } catch (e) { /* never leave the page hidden on error */ }
    reveal();
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();

/* Footer "Join the pack": top-level Shopify newsletter submit (server requires a captcha token); flag it so the popup reveals STEADY10 on return. */
(function(){
  if(window.__hmfNews) return; window.__hmfNews=1;
  var ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  document.addEventListener('submit',function(e){
    var form=e.target&&e.target.closest?e.target.closest('form[data-hmf-form]'):null; if(!form) return;
    var email=form.querySelector('[data-hmf-email]');
    if(!email||!ok.test((email.value||'').trim())){ e.preventDefault(); if(email) email.focus(); form.classList.add('hmf-err'); return; }
    try{localStorage.setItem('prNewsPending','1');}catch(x){}
    var fb=form.querySelector('.hm-btn')||form.querySelector('button[type="submit"]');
    if(fb&&!fb.classList.contains('is-loading')){ var o=fb.innerHTML; fb.classList.add('is-loading'); fb.innerHTML='<span class="hmf-spin" aria-hidden="true"></span>Unlocking your 10% off…'; setTimeout(function(){ if(fb.classList.contains('is-loading')){ fb.classList.remove('is-loading'); fb.innerHTML=o; } },15000); }
  },true);
  document.addEventListener('input',function(e){ var t=e.target; if(t&&t.matches&&t.matches('[data-hmf-email]')){ var f=t.closest('form'); if(f) f.classList.remove('hmf-err'); } });
  document.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest?e.target.closest('[data-hmf-code]'):null; if(!btn) return;
    var done=function(){ btn.classList.add('copied'); var cp=btn.querySelector('[data-hmf-cp]'); if(cp) cp.textContent='Copied \u2713'; };
    if(navigator.clipboard&&navigator.clipboard.writeText) navigator.clipboard.writeText('STEADY10').then(done,done);
    else { var ta=document.createElement('textarea'); ta.value='STEADY10'; document.body.appendChild(ta); ta.select(); try{document.execCommand('copy')}catch(x){} document.body.removeChild(ta); done(); }
  });
})();
